// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import ContactAddressSchema from './contact-address-schema';
import ContactCorrespondenceAddressSchema from './contact-correspondence-address-schema';
import DynamicFormPayloadSchema from './dynamic-form-payload-schema';
import DynamicFormFieldPayloadSchema from './dynamic-form-field-payload-schema';
import RequestSummarySchema from './request-summary-schema';

const schema = {
  $id: '/widget-register-for-event-request-schema',
  type: 'object',
  required: ['eventId', 'contactAddress', 'employmentGradePercent', 'id'],
  properties: {
    eventId: {
      type: 'integer',
    },
    contactAddress: {
      ...ContactAddressSchema,
    },
    invoiceAddress: {
      ...ContactCorrespondenceAddressSchema,
    },
    correspondenceAddress: {
      ...ContactCorrespondenceAddressSchema,
    },
    registrationAnswers: {
      ...DynamicFormPayloadSchema,
    },
    employmentPosition: {
      type: 'string',
      nullable: true,
    },
    employmentArea: {
      type: 'string',
      nullable: true,
    },
    employmentGradePercent: {
      type: 'integer',
    },
    employmentStartDate: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    comment: {
      type: 'string',
      nullable: true,
    },
    marketingAnswers: {
      type: 'array',
      nullable: true,
      items: { ...DynamicFormFieldPayloadSchema },
    },
    requestSummary: {
      ...RequestSummarySchema,
    },
    acceptNewsletter: {
      type: 'boolean',
    },
    acceptGdpr: {
      type: 'boolean',
    },
    languageIso2: {
      type: 'string',
      nullable: true,
    },
    id: {
      type: 'integer',
    },
  },
} as IJSONSchema;

export default schema;
